<template>
    <div>
        <div class="navbar-top">  
            <b-navbar toggleable="lg" type="light" varient="light">
    <b-navbar-brand href="#">
        <img src="../assets/images/logo/logo-black.png" alt="" style="height:60px">
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse" type="dark"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item>
            <router-link class="nav-link" :class="{'activeTab': $route.name == 'home'}" to="/">Home</router-link>
        </b-nav-item>
        <b-nav-item href="#">
            <router-link class="nav-link" :class="{'activeTab': $route.name == 'gallery'}" to="/gallery">Gallery</router-link>
        </b-nav-item>
        <b-nav-item href="#">
            <router-link class="nav-link" :class="{'activeTab': $route.name == 'contact'}" to="/contact">Contact</router-link>
        </b-nav-item>
        <b-nav-item href="#">
            <router-link class="nav-link" :class="{'activeTab': $route.name == 'about'}" to="/about">About</router-link>
        </b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>            
                <!-- <nav class="navbar navbar-expand-lg navbar-light bg-light justify-content-between">
                        <a class="navbar-brand" href="#">
                            <img src="../assets/images/logo/logo-black.png" alt="" style="height:60px">
                        </a>
                        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span class="navbar-toggler-icon"></span>
                        </button>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav ml-auto">
                            <li class="nav-item active">
                                 <router-link class="nav-link" :class="{'activeTab': $route.name == 'home'}" to="/">Home</router-link>
                          
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :class="{'activeTab': $route.name == 'gallery'}" to="/gallery">Gallery</router-link>
                              
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link"  :class="{'activeTab': $route.name == 'contact'}" to="/contact">Contact</router-link>
                                
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :class="{'activeTab': $route.name == 'about'}" to="/about">About</router-link>   
                            </li>
                           
                        </ul>
                    </div>
                </nav> -->
            </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            showNavbar: false,
            lastScrollPosition: 0
        }
    },
    mounted () {
        window.addEventListener('scroll', this.onScroll)
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
    onScroll () {
            // Get the current scroll position
        const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

        if(currentScrollPosition > 100){
            this.showNavbar = true;
        }else{
            this.showNavbar = false;
        }
    }
}
}
</script>




<style scoped>
.navbar {
    background: #fff !important;
    box-shadow: 0 9px 13px 0 rgba(0,0,0,.1);
    text-transform: uppercase;
    padding: 0 15px;
}
.navbar a{
    /* background-color: rgba(0, 0, 0, 0.295) !important; */
    color: #4a4a4a !important;
    font-weight: 400;
}

.nav-link{
    /* font-size:6px; */
    font-family: Raleway;
}

.nav-item{
    padding: 0px 10px;
    /* border-bottom: 2px solid transparent; */
    margin-bottom: -2px;
}
.navbar-top{
    position: fixed;
    background-color: transparent;
    top: 0;
    left: 0;
    width: 100%;
    font-size: 1.6rem;
    z-index: 999;
}

.navbar-nav .nav-link{
    font-size: 1.5rem;
    padding: .6rem 1rem;
    color: white;
}

.activeTab{
    /* background: #fbd020; */
    font-weight: 600 !important;
    border-bottom: 2px solid #fbd020;
}

@media (max-width: 700px){
    .activeTab{
        background: #fbd020;
        border-bottom: none;
    }
    .navbar-collapse{
        padding-bottom: 1.5rem;
    }
}
</style>
